/* global jQuery */
void (function initGallery($) {
	'use strict';
	$(document).ready(() => {
		$('.gallery--item').on('click', (event) => {
			const targetModuleTitle = $(event.target)
				.parents('.gallery')
				.attr('id');
			const targetLightbox = $(event.target)
				.parents('.gallery')
				.find('.lightbox-link');

			$(targetLightbox).attr('data-lightbox', targetModuleTitle);
		});
	});
})(jQuery);
